import { useEffect } from "react";
import { useLocation } from "react-router";
import { recordPageViewToRum } from "utils/cloudWatchRum";
import { normalizeClientPortalPageUrl } from "./useRumPageTracking.helpers";

export function useRumPageTracking(clientPortalGuid: string): void {
    const location = useLocation();

    useEffect(() => {
        recordPageViewToRum(normalizeClientPortalPageUrl(location.pathname, clientPortalGuid));
    }, [location.pathname, clientPortalGuid]);
}
